export default __webpack_public_path__ + "static/media/facebook-blue.f0f232f7.svg";